/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Capability_Sovereign_TitleInputs */

const en_landing_capability_sovereign_title = /** @type {(inputs: Landing_Capability_Sovereign_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign cloud deployment`)
};

/**
* | output |
* | --- |
* | "Sovereign cloud deployment" |
*
* @param {Landing_Capability_Sovereign_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_capability_sovereign_title = /** @type {((inputs?: Landing_Capability_Sovereign_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Capability_Sovereign_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_capability_sovereign_title(inputs)
});